module.exports = __webpack_public_path__ + "img/video-player/pause-61304f06cc9f2529d362d046ed8c207a.svg";